import { render, staticRenderFns } from "./c-footer-links.vue?vue&type=template&id=f30d6044&"
import script from "./c-footer-links.vue?vue&type=script&lang=js&"
export * from "./c-footer-links.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports